import React from "react";
import { Box, Typography, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { FormattedMessage } from "react-intl";
import IconLaunch from "@material-ui/icons/Launch";
import UserRoleLabel from "./UserRoleLabel";
import { Roles } from "../../../../util";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap-reverse",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.divider}`,
    gap: theme.spacing(1),
  },

  leftItem: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: "1 1 auto",
  },

  rightItem: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    alignItems: "flex-end",
    textAlign: "right",
    justifyContent: "flex-end",
    whiteSpace: "nowrap",
  },

  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: "auto",
    gap: theme.spacing(1),
  },
}));

const UserInfoSummary = ({ user, isAgent, currentUser, aptColor }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.leftItem}>
        <small style={{ color: aptColor[user.apt] }}>
          <FormattedMessage id={user.apt ? "app.apt" : "app.inapt"} />
        </small>

        <Typography
          variant="body1"
          color="textPrimary"
          noWrap
        >
          {user.email}
        </Typography>
      </Box>

      <Box className={classes.rightItem}>
        {isAgent && (
          <small
            style={{
              color: aptColor[user.contractAgentStatus === "ACTIVE"],
            }}
          >
            Agreement: <FormattedMessage id={`app.enuns.${user.contractAgentStatus}`} />
          </small>
        )}

        <Box className={classes.row}>
          <UserRoleLabel user={user} />

          {[Roles.Admin, Roles.FinanceManager].includes(currentUser.role) && (
            <IconButton
              size="small"
              href={`/user/${user.id}`}
              target="_blank"
            >
              <IconLaunch />
            </IconButton>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default UserInfoSummary;
